import React from "react";
import {
  ORDER_FLOW_TYPE,
  ORDER_TYPE_DELIVERY,
  PICKUP_STATUS,
  ORDER_PHASE_CONTACTING,
  SEARCH_DRIVER_IMAGE_URL,
  ORDER_STATUS_IMAGES,
  ORDER_STATUS_TEXT
} from "../../../constants";

import MapClient from "../../MapClient";
import _ from "lodash";
import { getShopFromOrder } from "../../../utils";
import { Box } from "@mui/material";

export default function OrderStatusStatus({
  order,
  chargeId,
  isMobile,
}: any) {
  if (_.isEmpty(order)) return null;

  const shop = getShopFromOrder(order);
  const { status, orderFlowType, pickupStatus, orderType } = order;

  const isSearchingDriver =
    orderFlowType === ORDER_FLOW_TYPE.REVERSE &&
    orderType === ORDER_TYPE_DELIVERY &&
    pickupStatus === PICKUP_STATUS.ORDER_NOT_CURRENTLY_SUPPORTED;

  const renderMap = (image: string, text: string) => (
    <Box position="relative" width="100%" height="100%" overflow="visible">
      <MapClient
        chargeId={chargeId}
        isMobile={isMobile}
        image={image}
        text={text}
        shopName={shop?.name}
      />
    </Box>
  );
  if (status === ORDER_PHASE_CONTACTING && isSearchingDriver) {
    return renderMap(
      SEARCH_DRIVER_IMAGE_URL,
      ORDER_STATUS_TEXT.SEARCHING_DRIVER
    );
  }

  const config = ORDER_STATUS_IMAGES[status];

  if (config) {
    return renderMap(config.image, config.text);
  }

  return renderMap(
    ORDER_STATUS_IMAGES.contacting.image,
    ORDER_STATUS_IMAGES.contacting.text
  );
}